/* MFAC micro-polish COMBINED — WRITE 2.5 only
   Press helper, Stories rail, sticky Configure (mobile), added toast, back-to-top.
   Never preventDefault on cart/forms. Fail-soft if nodes missing. */
(function () {
  var reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function qs(sel, root) {
    try { return (root || document).querySelector(sel); } catch (e) { return null; }
  }
  function qsa(sel, root) {
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; }
  }

  /* --- Press class --- */
  if (!reduce) {
    var SEL =
      '.btn:not(.btn--circle):not(.btn--search):not(.btn--close-search):not(.pswp__button),' +
      '.btn--primary,.btn--secondary,.btn--full,.add-to-cart.btn,' +
      '.product-form button[type="submit"],.element-button:not(.element-button--transparent),' +
      '.mfac-pres-explore__cta,#mfac-micro-btt,.mfac-micro-sticky-config__btn';
    function onDown(e) {
      var el = e.target && e.target.closest && e.target.closest(SEL);
      if (!el || el.disabled) return;
      el.classList.add('mfac-micro-pressed');
    }
    function onUp() {
      qsa('.mfac-micro-pressed').forEach(function (el) {
        el.classList.remove('mfac-micro-pressed');
      });
    }
    document.addEventListener('pointerdown', onDown, { passive: true });
    document.addEventListener('pointerup', onUp, { passive: true });
    document.addEventListener('pointercancel', onUp, { passive: true });
    document.addEventListener('blur', onUp, true);
  }

  /* --- Stories reading rail --- */
  function isStoriesArticle() {
    try {
      var path = (window.location && window.location.pathname) || '';
      if (!/\/blogs\/stories\//i.test(path)) return false;
      if (document.body && /template-article/i.test(document.body.className || '')) return true;
      return !!qs('article.article, .article__body, .article');
    } catch (err) {
      return false;
    }
  }
  if (!reduce && isStoriesArticle()) {
    var rail = qs('#mfac-micro-read-rail');
    if (!rail) {
      rail = document.createElement('div');
      rail.id = 'mfac-micro-read-rail';
      rail.setAttribute('aria-hidden', 'true');
      document.body.appendChild(rail);
    }
    var railTick = false;
    function updateRail() {
      railTick = false;
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop || 0;
      var height = Math.max((doc.scrollHeight || 0) - (window.innerHeight || 0), 1);
      rail.style.width = Math.min(100, Math.max(0, (scrollTop / height) * 100)).toFixed(2) + '%';
    }
    function onRailScroll() {
      if (railTick) return;
      railTick = true;
      window.requestAnimationFrame(updateRail);
    }
    window.addEventListener('scroll', onRailScroll, { passive: true });
    window.addEventListener('resize', onRailScroll, { passive: true });
    updateRail();
  }

  /* --- Sticky Configure (mobile product only): click real submit, no preventDefault --- */
  function initStickyConfig() {
    if (reduce) return;
    if (!document.body || !/template-product/i.test(document.body.className || '')) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;
    /* Story-led fast-lane already scrolls to #collect — do not ATC from a second sticky. */
    if (qs('[data-mfac-fast-lane]')) return;
    var form = qs('form.product-form, .product-form form, form[action*="/cart/add"]');
    var submit = qs(
      '.product-form button[type="submit"], form.product-form [type="submit"], .add-to-cart, [name="add"]',
      form || document
    );
    if (!form || !submit) return;

    var bar = qs('#mfac-micro-sticky-config');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'mfac-micro-sticky-config';
      bar.setAttribute('aria-hidden', 'true');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn--full mfac-micro-sticky-config__btn';
      btn.textContent = (submit.textContent || 'Configure').replace(/\s+/g, ' ').trim() || 'Configure';
      bar.appendChild(btn);
      document.body.appendChild(bar);
      btn.textContent = 'Configure your piece';
      btn.setAttribute('data-mfac-sticky-scroll', 'collect');
      btn.addEventListener('click', function (e) {
        try {
          if (e && e.preventDefault) e.preventDefault();
          var target =
            document.getElementById('collect') ||
            document.querySelector('[data-mfac-configure]') ||
            document.getElementById('configure');
          if (target && typeof target.scrollIntoView === 'function') {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            try { history.replaceState(null, '', '#collect'); } catch (err2) {}
            return;
          }
          window.location.hash = 'collect';
        } catch (err) {}
      });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );
    io.observe(submit);
  }

  /* --- Added confirmation (listen only; never block) --- */
  function initAddedToast() {
    if (reduce) return;
    var toast = qs('#mfac-micro-added');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mfac-micro-added';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = 'Added';
      document.body.appendChild(toast);
    }
    var hideTimer = null;
    function show() {
      toast.classList.add('is-in');
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        toast.classList.remove('is-in');
      }, 1600);
    }
    document.addEventListener('product-form:submit:success', show);
    document.addEventListener('cart:updated', show);
    document.addEventListener('ajaxProduct:added', show);
  }

  /* --- Back to top (long pages) --- */
  function initBackToTop() {
    if (reduce) return;
    var btt = qs('#mfac-micro-btt');
    if (!btt) {
      btt = document.createElement('button');
      btt.id = 'mfac-micro-btt';
      btt.type = 'button';
      btt.setAttribute('aria-label', 'Back to top');
      btt.innerHTML = '<span aria-hidden="true">↑</span>';
      document.body.appendChild(btt);
      btt.addEventListener('click', function () {
        try {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) {
          window.scrollTo(0, 0);
        }
      });
    }
    var tick = false;
    function update() {
      tick = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y > 900) btt.classList.add('is-visible');
      else btt.classList.remove('is-visible');
    }
    function onScroll() {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function boot() {
    try { initStickyConfig(); } catch (e) {}
    try { initAddedToast(); } catch (e) {}
    try { initBackToTop(); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
